import { render, staticRenderFns } from "./ABCClientes.vue?vue&type=template&id=efba08de&scoped=true&"
import script from "./ABCClientes.vue?vue&type=script&lang=js&"
export * from "./ABCClientes.vue?vue&type=script&lang=js&"
import style0 from "./ABCClientes.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./ABCClientes.vue?vue&type=style&index=1&id=efba08de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efba08de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardActions,VCol,VContainer,VIcon,VRow,VTooltip})
